import React, { Component } from 'react';
import Paper from '@mui/material/Paper';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

class Home extends Component {

  render() {
    
    return (
      <div>    
      < AppBar position = "fixed"
      style = {
        {
          backgroundColor: "#55565A",
          marginLeft: 260,
        }
      } >
        <Toolbar>
        <Typography variant="h5" style={{ marginLeft: 260 }}>
            My Home
          </Typography>
        </Toolbar>
    </AppBar>
        <Paper
      sx={{
          pl: 32.5,
          pb: 6.5,
          pt: 8,
          width: "100%",
          //position: "fixed",
        }}>

        < img src = {`${process.env.PUBLIC_URL}/images/banner3.jpg`}
            width="100%"
            alt="Desktop_Ad" />
        </Paper>
        </div>
    )

  }
}
export default Home